// ************  COMMON ENTITY CONVERSION FUNCTIONS  ************

import { MAX_TRANS_ID } from '../config.js';

// **********************************************************************
// ***  convert any entity (e.g. account) from API naming convention  ***
// ***  to UI naming convention                                       ***
// **********************************************************************

const convertEntityFromAPI = (origEntity) => {
    if (!origEntity) {
        return {};
    }
    const entity = {};
    if (origEntity.id !== undefined && origEntity.id !== null) {
        entity.id = origEntity.id;
    }
    if (origEntity.version) {
        entity.version = origEntity.version;
    }
    if (origEntity.create_user) {
        entity.createUser = origEntity.create_user;
    }
    if (origEntity.create_ts) {
        entity.createTimestamp = origEntity.create_ts;
    }
    if (origEntity.update_user) {
        entity.updateUser = origEntity.update_user;
    }
    if (origEntity.update_ts) {
        entity.updateTimestamp = origEntity.update_ts;
    }
    return entity;
};

// *********************************************************************
// ***  convert any entity (e.g. account) from UI naming convention  ***
// ***  to API naming convention                                     ***
// *********************************************************************

const convertEntityToAPI = (origEntity) => {
    if (!origEntity) {
        return {};
    }
    const entity = {};
    if (origEntity.id !== undefined && origEntity.id !== null && origEntity.id < MAX_TRANS_ID) {
        entity.id = origEntity.id;
    }
    if (origEntity.version) {
        entity.version = origEntity.version;
    }
    if (origEntity.createUser) {
        entity.create_user = origEntity.createUser;
    }
    if (origEntity.createTimestamp) {
        entity.create_ts = origEntity.createTimestamp;
    }
    if (origEntity.updateUser) {
        entity.update_user = origEntity.updateUser;
    }
    if (origEntity.updateTimestamp) {
        entity.update_ts = origEntity.updateTimestamp;
    }
    return entity;
};

// ************  OPTION CONVERSION FUNCTIONS  ************

// ***************************************************************************
// ***  convert any option (e.g. account_type) from API naming convention  ***
// ***  to UI naming convention                                            ***
// ***************************************************************************

const convertOptionFromAPI = (origOption) => {
    if (!origOption) {
        return {};
    }
    const option = convertEntityFromAPI(origOption);
    if (origOption.code) {
        option.code = origOption.code;
    }
    if (origOption.description) {
        option.description = origOption.description;
    }
    return option;
};

// ******************************************************************************
// ***  convert any list of options (e.g. list of account_type options) from  ***
// ***  API naming convention to UI naming convention                         ***
// ******************************************************************************

const convertOptionListFromAPI = (origOptionList) => {
    if (!Array.isArray(origOptionList)) {
        return [];
    }
    const optionList = [];
    for (const option of origOptionList) {
        optionList.push(convertOptionFromAPI(option));
    }
    return optionList;
};

// **************************************************************************
// ***  convert any option (e.g. account_type) from UI naming convention  ***
// ***  to API naming convention                                          ***
// **************************************************************************

const convertOptionToAPI = (origOption) => {
    const option = convertEntityToAPI(origOption);
    if (origOption.code) {
        option.code = origOption.code;
    }
    if (origOption.description) {
        option.description = origOption.description;
    }
    return option;
};

// ******************************************************************************
// ***  convert any list of options (e.g. list of account_type options) from  ***
// ***  UI naming convention to API naming convention                         ***
// ******************************************************************************

const convertOptionListToAPI = (origOptionList) => {
    if (!Array.isArray(optionList)) {
        return [];
    }
    const optionList = [];
    for (const option of origOptionList) {
        optionList.push(convertOptionToAPI(option));
    }
    return optionList;
};

// ****************************************************************
// ***  expose API Utility Method Calls to API Services
// ****************************************************************

export const commonAPIConversion = {
    convertEntityFromAPI,
    convertEntityToAPI,
    convertOptionFromAPI,
    convertOptionListFromAPI,
    convertOptionToAPI,
    convertOptionListToAPI
};